// Module
var code = "<div ng-controller=\"CreatePaymentController\" class=\"view-contents\"> <div ng-include=\"'/app/payables/ach/payments/views/createPaymentSingleBatchTemplate.html'\" style=\"height:100%\" ng-init=\"isNewPayment = true\"></div> </div> ";
// Exports
module.exports = code;